import { render, staticRenderFns } from "./updateQtyRecord.vue?vue&type=template&id=67a00615&scoped=true"
import script from "./updateQtyRecord.vue?vue&type=script&lang=js"
export * from "./updateQtyRecord.vue?vue&type=script&lang=js"
import style0 from "./updateQtyRecord.vue?vue&type=style&index=0&id=67a00615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a00615",
  null
  
)

export default component.exports